import { useState } from 'react';
import { DropDownIcon, DropUpIcon, styled } from '@attentive-platform/stem-ui';
import { EstimatorType } from './types';
import { Typography } from '../Typography';
import { UserScope } from './UserScope';
import { Accordion, AccordionDetails, AccordionSummary } from '../Accordion';
import { styledAccordion, styledAccordionHeading, styledAssignments } from './styles';
import { AssignmentState } from './useScopeChange';

const StyledAccordionDetails = styled(AccordionDetails)(() => ({
  padding: 0,
  '.checkbox': {
    marginRight: 0,
    paddingLeft: '0.5rem',
    '.MuiCheckbox-root': { padding: '2px', svg: { width: '1rem', height: '1rem' } }
  }
}));

type TradeScopeProps = {
  assignments: AssignmentState[];
  authenticatedUser: any;
  userPersona?: EstimatorType;
  tradeId: string;
};

export const TradeScope = ({ assignments, authenticatedUser, userPersona, tradeId }: TradeScopeProps) => {
  const [expandQCAssignments, setExpandQCAssignments] = useState(true);
  const [expandQAAssignments, setExpandQAAssignments] = useState(true);

  const QCAssignments = (assignments || []).filter(
    assignment => assignment.estimator_type === EstimatorType.QUALITY_CONTROL
  );
  const QAAssignments = (assignments || []).filter(
    assignment => assignment.estimator_type === EstimatorType.QUALITY_ASSURANCE
  );

  return (
    <div className={styledAssignments}>
      <Accordion
        color='primary'
        className={styledAccordion}
        expanded={expandQCAssignments}
        onChange={() => setExpandQCAssignments(prev => !prev)}
        showSeparator>
        <AccordionSummary
          className={styledAccordionHeading}
          expandIcon={expandQCAssignments ? <DropDownIcon /> : <DropUpIcon />}
          bgColor='primary'>
          <Typography variant='subtitle2-medium'>QC(s)</Typography>
        </AccordionSummary>
        <StyledAccordionDetails>
          {QCAssignments.map(assignment => (
            <UserScope
              assignment={assignment}
              userPersona={userPersona}
              isCurrentUser={authenticatedUser.id === assignment.user.id}
              tradeId={tradeId}
            />
          ))}
        </StyledAccordionDetails>
      </Accordion>
      <Accordion
        color='primary'
        className={styledAccordion}
        expanded={expandQAAssignments}
        onChange={() => setExpandQAAssignments(prev => !prev)}>
        <AccordionSummary
          className={styledAccordionHeading}
          expandIcon={expandQAAssignments ? <DropDownIcon /> : <DropUpIcon />}
          bgColor='primary'>
          <Typography variant='subtitle2-medium'>QA(s)</Typography>
        </AccordionSummary>
        <StyledAccordionDetails>
          {QAAssignments.map(assignment => (
            <UserScope
              assignment={assignment}
              isCurrentUser={authenticatedUser.id === assignment.user.id}
              userPersona={userPersona}
              isQcScope={false}
              tradeId={tradeId}
            />
          ))}
        </StyledAccordionDetails>
      </Accordion>
    </div>
  );
};
